<p class="filter-range-title" [class.is-loading]="isLoading | async">
    <span>{{ minValueSelected || minValue | number }} </span>
    -
    <span>
        {{ maxValueSelected || maxValue | number }}hrs @if (maxValueSelected ===
        configuration.hoursMaxValue) {
        <i>+</i>
        }
    </span>
</p>

<ras-filter-range-slider
    [selectedMax]="maxValueSelected"
    [selectedMin]="minValueSelected"
    [max]="maxValue"
    [min]="minValue"
    [isCurrency]="false"
    suffix="hrs"
    [increment]="configuration.hoursIncrement"
    (rangeChange)="onChange($event)"
>
</ras-filter-range-slider>
